import { createTheme } from 'baseui';

import ldtTheme from '@letsdothis/lds/lib/ldt_theme';

/*
 Create theme creates all required props to make baseui working properly, and then
 our theme overwrites them. It's a fallback for future if baseui adds some
 new props, and we don't have them in our theme.
 */
const LdtTheme = {
  ...createTheme(),
  ...ldtTheme,
};

export { LdtTheme };
